import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import {
  ErrorMessage,
  FormControl,
  Heading,
  HStack,
  Input,
  SuccessMessage,
  VStack,
} from '@ayble-health/dashboard-components';
import { Button } from 'components/ui/button';
import { useCoachLogin } from '../../api/auth/mutations/useCoachLogin';

export const Headline = () => {
  const [email, setEmail] = useState<string>();
  const { mutation } = useCoachLogin();

  return (
    <VStack alignItems={'center'} bgColor={'secondary.500'}>
      <HStack
        bgColor={'muted.100'}
        mt={8}
        p={[6, 20]}
        rounded={['32px', '64px']}
      >
        <VStack flex={2}>
          <Heading fontWeight={'medium'} fontSize={['3xl', '5xl']}>
            Care Team Dashboard
          </Heading>

          <Box mt={3}>
            <>
              {mutation.isSuccess && (
                <SuccessMessage message={`Login link sent to: ${email}`} />
              )}
              {mutation.error && (
                <ErrorMessage message=" Sorry, there was an error. Please try again or contact support." />
              )}
            </>
          </Box>

          <FormControl mt={3}>
            <FormControl.Label>Email</FormControl.Label>
            <Input
              type="text"
              placeholder="example@ayblehealth.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button
              disabled={!email}
              maxW={'200px'}
              // Preserve the pre-migration look (light teal bg + dark text).
              // The default `solid` variant is now mobile-aligned (evergreen
              // bg + white text); this landing CTA stayed visually lighter.
              bg={'primary.500'}
              color={'secondary.600'}
              _hover={{ bg: 'primary.600' }}
              onClick={() => {
                mutation.mutate(email);
              }}
            >
              Send Login Link
            </Button>
          </FormControl>
        </VStack>
      </HStack>
    </VStack>
  );
};
